var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "DemoFormViews" } }, [
    _c("h3", { staticStyle: { "text-align": "center" } }, [
      _vm._v(_vm._s(_vm.$t("demoFormViews.mainTitle"))),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-between" } },
      [
        _c("div", { staticClass: "page-one" }, [
          _c(
            "h5",
            { staticStyle: { "text-align": "center", padding: "20px" } },
            [_vm._v(_vm._s(_vm.$t("demoFormViews.purposeSectionTitle")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("h3", { staticClass: "sup-title" }, [
              _vm._v(_vm._s(_vm.$t("demoFormViews.purposeQuestion"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-one-content", attrs: { id: "CheckboxOne" } },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "pageTwo-title" }, [
                  _c("h5", { staticClass: "sup-title" }, [
                    _vm._v(_vm._s(_vm.$t("demoFormViews.chatbotTitle"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("demoFormViews.chatbotDescription"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", { staticClass: "ls-checkbox-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedOptions,
                          expression: "selectedOptions",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "chatbot",
                        name: "chatbot",
                        value: "chatbot",
                        disabled: true,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.selectedOptions)
                          ? _vm._i(_vm.selectedOptions, "chatbot") > -1
                          : _vm.selectedOptions,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.selectedOptions,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "chatbot",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.selectedOptions = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedOptions = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedOptions = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ls-checkbox-checkmark" }),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-one-content", attrs: { id: "CheckboxTwo" } },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "pageTwo-title" }, [
                  _c("h5", { staticClass: "sup-title" }, [
                    _vm._v(_vm._s(_vm.$t("demoFormViews.aiAssistantTitle"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("demoFormViews.aiAssistantDescription"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", { staticClass: "ls-checkbox-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedOptions,
                          expression: "selectedOptions",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "aiAsistan",
                        name: "aiAsistan",
                        value: "aiAsistan",
                        disabled: true,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.selectedOptions)
                          ? _vm._i(_vm.selectedOptions, "aiAsistan") > -1
                          : _vm.selectedOptions,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.selectedOptions,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "aiAsistan",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.selectedOptions = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedOptions = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedOptions = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ls-checkbox-checkmark" }),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "page-one-content",
                attrs: { id: "CheckboxThree" },
              },
              [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "pageTwo-title" }, [
                  _c("h5", { staticClass: "sup-title" }, [
                    _vm._v(_vm._s(_vm.$t("demoFormViews.liveSupportTitle"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("demoFormViews.liveSupportDescription"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("label", { staticClass: "ls-checkbox-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedOptions,
                          expression: "selectedOptions",
                        },
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "livesupport",
                        name: "livesupport",
                        value: "livesupport",
                        disabled: true,
                      },
                      domProps: {
                        checked: Array.isArray(_vm.selectedOptions)
                          ? _vm._i(_vm.selectedOptions, "livesupport") > -1
                          : _vm.selectedOptions,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.selectedOptions,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "livesupport",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.selectedOptions = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedOptions = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedOptions = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ls-checkbox-checkmark" }),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-two" }, [
          _c(
            "h5",
            { staticStyle: { "text-align": "center", padding: "20px" } },
            [_vm._v(_vm._s(_vm.$t("demoFormViews.modulesSectionTitle")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("h3", { staticClass: "sup-title" }, [
              _vm._v(_vm._s(_vm.$t("demoFormViews.modulesQuestion"))),
            ]),
            _vm._v(" "),
            _vm.pageOne
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxFour" },
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleWhatsappBulk"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "bulkWhatsappMessageManagement",
                              type: "checkbox",
                              name: "bulkWhatsappMessageManagement",
                              value: "bulkWhatsappMessageManagement",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "bulkWhatsappMessageManagement"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "bulkWhatsappMessageManagement",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxFive" },
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("demoFormViews.moduleDynamicAiChatbot")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "dynamicArtificialIntelligenceAndChatbot",
                              type: "checkbox",
                              name: "dynamicArtificialIntelligenceAndChatbot",
                              value: "dynamicArtificialIntelligenceAndChatbot",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "dynamicArtificialIntelligenceAndChatbot"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v =
                                      "dynamicArtificialIntelligenceAndChatbot",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxSix" },
                    },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleVideoVoice"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "videoAndVoiceCall",
                              type: "checkbox",
                              name: "videoAndVoiceCall",
                              value: "videoAndVoiceCall",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "videoAndVoiceCall"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "videoAndVoiceCall",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxSeven" },
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("demoFormViews.moduleMailCrm"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "mailManagementAndCRM",
                              type: "checkbox",
                              name: "mailManagementAndCRM",
                              value: "mailManagementAndCRM",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "mailManagementAndCRM"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "mailManagementAndCRM",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pageTwo
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxEight" },
                    },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("demoFormViews.moduleWebSegmentation")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "websiteAnalysisAndSegmentation",
                              type: "checkbox",
                              name: "websiteAnalysisAndSegmentation",
                              value: "websiteAnalysisAndSegmentation",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "websiteAnalysisAndSegmentation"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "websiteAnalysisAndSegmentation",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxNine" },
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleTranslation"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "translationInEveryLanguage",
                              type: "checkbox",
                              name: "translationInEveryLanguage",
                              value: "translationInEveryLanguage",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "translationInEveryLanguage"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "translationInEveryLanguage",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxTen" },
                    },
                    [
                      _vm._m(9),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleTriggers"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "triggers",
                              type: "checkbox",
                              name: "triggers",
                              value: "triggers",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(_vm.selectedOptionsTwo, "triggers") >
                                  -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "triggers",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxEleven" },
                    },
                    [
                      _vm._m(10),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("demoFormViews.moduleAdvancedReporting")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "advancedReporting",
                              type: "checkbox",
                              name: "advancedReporting",
                              value: "advancedReporting",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "advancedReporting"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "advancedReporting",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pageThree
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxTwelve" },
                    },
                    [
                      _vm._m(11),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleAiAssistant"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "artificialIntelligenceAssistant",
                              type: "checkbox",
                              name: "artificialIntelligenceAssistant",
                              value: "artificialIntelligenceAssistant",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "artificialIntelligenceAssistant"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "artificialIntelligenceAssistant",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxThirteen" },
                    },
                    [
                      _vm._m(12),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleInternalComms"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "internalCommunication",
                              type: "checkbox",
                              name: "internalCommunication",
                              value: "internalCommunication",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "internalCommunication"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "internalCommunication",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxFourteen" },
                    },
                    [
                      _vm._m(13),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleCrmBusiness"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "crmAndBusinessManagementSystem",
                              type: "checkbox",
                              name: "crmAndBusinessManagementSystem",
                              value: "crmAndBusinessManagementSystem",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "crmAndBusinessManagementSystem"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "crmAndBusinessManagementSystem",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-three-content",
                      attrs: { id: "CheckboxFifteen" },
                    },
                    [
                      _vm._m(14),
                      _vm._v(" "),
                      _c("div", { staticClass: "pageThree-text" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("demoFormViews.moduleAutoBooking"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "ls-checkbox-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOptionsTwo,
                                expression: "selectedOptionsTwo",
                              },
                            ],
                            attrs: {
                              id: "automaticReservationSystem",
                              type: "checkbox",
                              name: "automaticReservationSystem",
                              value: "automaticReservationSystem",
                              disabled: true,
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedOptionsTwo)
                                ? _vm._i(
                                    _vm.selectedOptionsTwo,
                                    "automaticReservationSystem"
                                  ) > -1
                                : _vm.selectedOptionsTwo,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedOptionsTwo,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "automaticReservationSystem",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedOptionsTwo = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedOptionsTwo = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedOptionsTwo = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ls-checkbox-checkmark" }),
                        ]),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { attrs: { id: "pageThreeFooter" } }, [
              _c("div", { staticClass: "page-footer-back-btn" }, [
                _c(
                  "div",
                  {
                    staticClass: "sup-back-btn",
                    attrs: { id: "backBtnOne" },
                    on: { click: _vm.backBtn },
                  },
                  [_vm._v("<")]
                ),
              ]),
              _vm._v(" "),
              _vm._m(15),
              _vm._v(" "),
              _c("div", { staticClass: "page-footer-next-btn" }, [
                _c(
                  "div",
                  {
                    staticClass: "sup-next-btn",
                    attrs: { id: "nextBtnOne" },
                    on: { click: _vm.nexBtn },
                  },
                  [_vm._v(">")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: "https://widget.supsis.live/style/icon/ChatbotIcon.png",
          alt: "chatbot",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: "https://widget.supsis.live/style/icon/AiIcon.png",
          alt: "chatbot",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "77px" } }, [
      _c("img", {
        attrs: {
          src: "https://widget.supsis.live/style/icon/ChatBalloonIcon.png",
          alt: "chatbot",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/WhatsappIcon.png",
          alt: "WhatsappIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/ChatbotIconAI.png",
          alt: "ChatbotAI",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/VideoCallIcon.png",
          alt: "chatbot",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/MailIcon.png",
          alt: "chatbot",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/WebSiteIcon.png",
          alt: "WebSiteIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/TranslateIcon.png",
          alt: "TransLateIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/TriggerIcon.png",
          alt: "TriggerIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/ReportIcon.png",
          alt: "chatbot",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/AiIcon.png",
          alt: "WebSiteIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/teamIcon.png",
          alt: "WebSiteIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/CRMicon.png",
          alt: "WebSiteIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-margin-top-30" }, [
      _c("img", {
        staticClass: "sup-img-width",
        attrs: {
          src: "https://widget.supsis.live/style/icon/calendarIcon.png",
          alt: "WebSiteIcon",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sup-page-round" }, [
      _c("div", {
        staticClass: "page-round-item page-round-item-active",
        attrs: { id: "pageRoundOne" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "page-round-item",
        attrs: { id: "pageRoundTwo" },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "page-round-item",
        attrs: { id: "pageRoundThree" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }